"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../lib/mathquill.min");

var _MathquillMenuTab = _interopRequireDefault(require("./MathquillMenuTab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MathquillUIMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MathquillUIMenu, _React$PureComponent);

  var _super = _createSuper(MathquillUIMenu);

  function MathquillUIMenu() {
    var _this;

    _classCallCheck(this, MathquillUIMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      clickedTabId: null,
      showing: false
    });

    _defineProperty(_assertThisInitialized(_this), "onTabNameClick", function () {
      var _this2;

      return (_this2 = _this).__onTabNameClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "show", function () {
      var _this3;

      return (_this3 = _this).__show__REACT_HOT_LOADER__.apply(_this3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      var _this4;

      return (_this4 = _this).__hide__REACT_HOT_LOADER__.apply(_this4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSymbolClick", function () {
      var _this5;

      return (_this5 = _this).__onSymbolClick__REACT_HOT_LOADER__.apply(_this5, arguments);
    });

    return _this;
  }

  _createClass(MathquillUIMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof this.props.onInstanceReady === 'function') {
        this.props.onInstanceReady(this);
      }
    }
  }, {
    key: "__onTabNameClick__REACT_HOT_LOADER__",
    value: function __onTabNameClick__REACT_HOT_LOADER__(event) {
      event.preventDefault();
      var menuTabId = event.target.getAttribute('data-menutabid');
      this.setState({
        clickedTabId: menuTabId
      });
    }
  }, {
    key: "__show__REACT_HOT_LOADER__",
    value: function __show__REACT_HOT_LOADER__() {
      this.setState({
        showing: true
      });
    }
  }, {
    key: "__hide__REACT_HOT_LOADER__",
    value: function __hide__REACT_HOT_LOADER__() {
      this.setState({
        showing: false,
        clickedTabId: null
      });
    }
  }, {
    key: "__onSymbolClick__REACT_HOT_LOADER__",
    value: function __onSymbolClick__REACT_HOT_LOADER__(symbolData) {
      var currentMath = this.props.currentMath;
      var isCommand = symbolData.isCommand !== false;

      if (isCommand) {
        currentMath.cmd(symbolData.latex);
      } else {
        currentMath.write(symbolData.latex);
      }

      currentMath.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          captions = _this$props.captions,
          menuData = _this$props.menuData;
      var numberOfTabs = menuData.length;
      var menuItems = [];
      var menuTabs = [];
      menuData.forEach(function (menuTab, i) {
        var clickedTabId = _this6.state.clickedTabId;
        var captionKey = "".concat(menuTab.id, "Tab");
        var ariaLabel = captions.mathQuill[captionKey];
        menuItems.push( /*#__PURE__*/_react.default.createElement("li", {
          key: "MathquillMenuTabName".concat(menuTab.id),
          className: i === 0 && !clickedTabId || clickedTabId === menuTab.id ? 'current' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          "aria-label": ariaLabel,
          "data-menutabid": menuTab.id,
          href: "#".concat(menuTab.id, "Tab"),
          onClick: _this6.onTabNameClick
        }, menuTab.label)));
        menuTabs.push( /*#__PURE__*/_react.default.createElement(_MathquillMenuTab.default, {
          captions: _this6.props.captions,
          key: "MathquillMenuTab".concat(menuTab.id),
          isFirstTab: i === 0,
          clickedTabId: clickedTabId,
          symbolClickHandler: _this6.onSymbolClick,
          menuTab: menuTab
        }));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.menuClass + (this.state.showing ? '' : ' hidden'),
        ref: function ref(div) {
          _this6.componentNode = div;
        }
      }, numberOfTabs > 1 ? /*#__PURE__*/_react.default.createElement("ul", {
        className: "mq-tabs-menu",
        role: "menu"
      }, menuItems) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: "tab",
        role: "menu"
      }, menuTabs));
    }
  }]);

  return MathquillUIMenu;
}(_react.default.PureComponent);

_defineProperty(MathquillUIMenu, "propTypes", {
  captions: _propTypes.default.object,
  menuClass: _propTypes.default.string,
  menuData: _propTypes.default.array.isRequired,
  currentMath: _propTypes.default.object,
  onInstanceReady: _propTypes.default.func
});

_defineProperty(MathquillUIMenu, "defaultProps", {
  menuClass: 'mathquill-ui-menu',
  currentMath: undefined
});

var _default = MathquillUIMenu;
var _default2 = _default;
exports.default = _default2;
module.exports = exports["default"];
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MathquillUIMenu, "MathquillUIMenu", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIMenu.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/js/components/MathquillUIMenu.js");
}();

;